import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Document } from 'app/models/dto/document.model';
import { environment } from 'environments/environment';
import { ApiHttpClient } from 'app/http/clients/api';
import { Activity } from 'app/modules/activity/models/activity/activity.model';

@Injectable({
    providedIn: 'root'
})
export class OcrolusService {
    constructor(private http: ApiHttpClient) { }

    sendToOcrolus(borrowerId: number, docIds: number[], append = false): Observable<Document[]> {
        const params = {};
        params['append'] = append;
        params['documentIds'] = docIds;
        return this.http.put<Document[]>(`${environment.API_URL}/borrower/${borrowerId}/ocrolus`, params);
    }

    getOcrolusActivity(borrowerId: number): Observable<Activity[]> {
        const query = {
            criteria: {
                'activities.borrowerId': {
                    '==': borrowerId
                },
                'activities.type': {
                    'in': [
                        'ocrolusSucceeded',
                        'ocrolusFailed',
                        'ocrolusSubmitted',
                        'ocrolusFailedToCreateBook',
                        'ocrolusDocumentCategoryUpdated',
                        'ocrolusDocumentCategoryVerified',
                        'ocrolusDocumentRejected',
                        'ocrolusDocumentCategoryUnknown'
                    ]
                }
            },
            sort: {
                'activities.created': 'DESC'
            },
            limit: 1
        };
        const queryString = encodeURIComponent(JSON.stringify(query));
        return this.http.get<Activity[]>(`${environment.API_URL}/activity?query=${queryString}`);
    }
}
